import { api } from "@/api/axios.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiFormViewScalePayload } from "@/types/forms/form-scale.types.ts";
import { ApiFormViewScale, ApiFormViewScaleFilter } from "@/types/forms/form-view.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";

export const apiScales = {
  search: async function (filter: ApiFormViewScaleFilter, signal: AbortSignal) {
    return api.post<ApiPagedData<ApiFormViewScale>>("/api/v1/forms/scales/search", filter, signal);
  },
  create: async function (payload: ApiFormViewScalePayload) {
    return api.post<ApiFormViewScale>(`/api/v1/forms/scales`, payload);
  },
  update: async function (id: number, payload: ApiFormViewScalePayload) {
    return api.put<ApiFormViewScale>(`/api/v1/forms/scales/${id}`, payload);
  },
  delete: async function (id: number) {
    return api.delete<ApiOperationResult>(`/api/v1/forms/scales/${id}`);
  },
};
